export default function Tooltip({ text }) {
  return (
    <div className="absolute bottom-full mb-3 left-1/2 -translate-x-1/2 w-70 p-2 bg-[#092F7B] text-center text-white text-xs rounded-[8px] opacity-0 group-hover:opacity-100 transition whitespace-normal break-words z-10 shadow-lg leading-[20px] tracking-[0%]">
      {text}
      <div className="relative">
        <div className="absolute bottom-full mb-[-14px] left-1/2 -translate-x-1/2 w-4 h-4 bg-[#092F7B] opacity-0 group-hover:opacity-100 transition  rotate-45 z-10"></div>
      </div>
    </div>
  );
}
